/* Charmies pixel tracking — Meta + TikTok.
 * Base pixels are initialised in snippets/charmies-pixels-head.liquid (fbq/ttq
 * loaded with IDs from theme settings). This module fires the standard
 * e-commerce events with rich params, mirroring the Lovable app
 * (src/lib/meta-pixel.ts + tiktok-pixel.ts). Each event carries a dedup id
 * (eventID / event_id) for server-side CAPI/Events-API matching.
 * Consent is honoured via Shopify's Customer Privacy API when present.
 */
(function () {
  var CURRENCY = (window.CHARMIES && window.CHARMIES.currency) || 'QAR';

  function canTrack() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.userCanBeTracked === 'function') return cp.userCanBeTracked();
    } catch (e) {}
    return true; // default allow when the API isn't available
  }

  function uid() {
    try {
      if (window.crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, '').slice(0, 16);
    } catch (e) {}
    return Math.random().toString(16).slice(2, 18);
  }

  function fbTrack(name, params) {
    if (!canTrack() || typeof window.fbq !== 'function') return;
    try { window.fbq('track', name, params || {}, { eventID: uid() }); } catch (e) {}
  }
  function ttTrack(name, params) {
    if (!canTrack() || !window.ttq || typeof window.ttq.track !== 'function') return;
    try { window.ttq.track(name, params || {}, { event_id: uid() }); } catch (e) {}
  }

  // items: [{ id, quantity, price, name }]
  function metaContents(items) { return items.map(function (i) { return { id: i.id, quantity: i.quantity || 1 }; }); }
  function metaIds(items) { return items.map(function (i) { return i.id; }); }
  function ttContents(items, fallbackName) {
    return items.map(function (i) {
      return { content_id: i.id, content_type: 'product', content_name: i.name || fallbackName, quantity: i.quantity || 1, price: i.price };
    });
  }

  window.CharmiesPixels = {
    viewContent: function (o) {
      var items = o.items || [];
      fbTrack('ViewContent', { content_name: o.contentName, content_ids: metaIds(items), content_type: 'product', contents: metaContents(items), value: o.value, currency: CURRENCY });
      ttTrack('ViewContent', { contents: ttContents(items, o.contentName), content_type: 'product', content_name: o.contentName, value: o.value, currency: CURRENCY });
    },
    addToCart: function (o) {
      var items = o.items || [];
      fbTrack('AddToCart', { content_name: o.contentName, content_ids: metaIds(items), content_type: 'product', contents: metaContents(items), value: o.value, currency: CURRENCY });
      ttTrack('AddToCart', { contents: ttContents(items, o.contentName), content_type: 'product', content_name: o.contentName, value: o.value, currency: CURRENCY });
    },
    initiateCheckout: function (o) {
      var items = o.items || [];
      var numItems = items.reduce(function (a, i) { return a + (i.quantity || 1); }, 0);
      fbTrack('InitiateCheckout', { content_ids: metaIds(items), content_type: 'product', contents: metaContents(items), value: o.value, num_items: numItems, currency: CURRENCY });
      ttTrack('InitiateCheckout', { contents: ttContents(items, o.contentName), content_type: 'product', value: o.value, currency: CURRENCY });
    },
    purchase: function (o) {
      var items = o.items || [];
      fbTrack('Purchase', { content_ids: metaIds(items), content_type: 'product', contents: metaContents(items), value: o.value, order_id: o.orderId, currency: CURRENCY });
      ttTrack('CompletePayment', { contents: ttContents(items, o.contentName), content_type: 'product', value: o.value, order_id: o.orderId, currency: CURRENCY });
    },
  };
})();
